
import { useTheme } from '../../contexts/ThemeContext';
import { Link } from 'react-router-dom';

export default function Footer() {
  const { theme } = useTheme();
  
  return (
    <footer className={`${theme === 'dark' ? 'bg-gray-800 border-gray-700' : 'bg-white border-gray-200'} border-t`}>
      <div className="px-6 py-4">
        <div className={`flex items-center justify-between text-sm ${
          theme === 'dark' ? 'text-gray-400' : 'text-gray-600'
        }`}>
          <div>
            &copy; {new Date().getFullYear()} FlowCXP. All rights reserved.
          </div>
          <div className="flex space-x-4">
            <Link to="/privacy-policy" className={`${
              theme === 'dark' ? 'hover:text-gray-200' : 'hover:text-gray-900'
            }`}>Privacy Policy</Link>
            <Link to="/terms-of-service" className={`${
              theme === 'dark' ? 'hover:text-gray-200' : 'hover:text-gray-900'
            }`}>Terms of Service</Link>
          </div>
        </div>
      </div>
    </footer>
  );
}
